import $ from 'jquery';

const defaults = {
  viewName: 'member-resource-search',
  buttonVal: 'Reset',
};

export default class FileListTemplate {
  constructor(element, options) {
    this.element = element;
    this.$element = $(element);
    this.settings = Object.assign(defaults, options);
    this.reset = this.reset.bind(this);
    this.process();
    this.truncateOptions();
    this.ready();
  }

  process() {
    this.$element.find('.views-exposed-widget').each((i, element) => {
      if ($(element).is('.views-submit-button')) {
        const $resetButton = $(`<input type="reset" value="${this.settings.buttonVal}" id="reset-${this.settings.viewName}">`);
        $resetButton
          .bind('click', this.reset)
          .appendTo(element);
      }
    });

    if (this.$element.find('.view-content').length === 0) {
      this.$element.find('.view-footer').show();
    }
  }

  truncateOptions() {
    this.$element.find('#edit-field-profiles-nid-1').children().each((i, elem) => {
      const optionText = $(elem).text();
      const newText = optionText.split(':')[1];
      $(elem).text(newText);
    });
  }

  reset() {
    this.$element.find('input[type="text"]').attr('value', '');
    const url = window.location.href;
    const baseUrl = url.substring(0, url.indexOf('?'));
    window.location.href = baseUrl;
  }

  ready() {
    return this.$element.addClass('ready');
  }
}
